import { EntityId } from "@jackfruit/common"
import { ActionCreatorWithPayload, PayloadAction } from "@reduxjs/toolkit"
import { VNZImageEntity } from "~/interfaces/entities/VNZImage"
import { createEntitySlice } from "../createEntitySlice"
import type { EnhancedEntityState } from "../store"

export interface LoadThumbnailForImagePayload {
  id: EntityId
}

export interface LoadFullImageForImagePayload {
  id: EntityId
}

export interface VNZImagesState extends EnhancedEntityState<VNZImageEntity> {
  count: number
  hasMore: boolean
}

interface VNZImagesActions {
  setCount: ActionCreatorWithPayload<number>
  setHasMore: ActionCreatorWithPayload<boolean>
  loadThumbnailForImage: ActionCreatorWithPayload<LoadThumbnailForImagePayload>
  loadFullImageForImage: ActionCreatorWithPayload<LoadFullImageForImagePayload>
}

const { slice, selectors: vnzImagesSelectors } =
  createEntitySlice<VNZImageEntity>(
    "VNZImages",
    {},
    {
      count: 0,
      hasMore: true,
    },
    {
      setCount(state, action: PayloadAction<number>) {
        state.count = action.payload
      },
      setHasMore(state, action: PayloadAction<boolean>) {
        state.hasMore = action.payload
      },
      loadThumbnailForImage(
        state,
        action: PayloadAction<LoadThumbnailForImagePayload>
      ) {},

      loadFullImageForImage(
        state,
        action: PayloadAction<LoadFullImageForImagePayload>
      ) {},
    }
  )

const vnzImages = {
  ...slice,
  actions: slice.actions as typeof slice.actions & VNZImagesActions,
}

export { vnzImages, vnzImagesSelectors }
